document.addEventListener('DOMContentLoaded', () => {
    NAV.onReady();
    FORM.onReady();
    TINYSLIDER.onReady();
    SCROLLER.onReady();
    MAPS.onReady();
    TOGGLER.onReady();
    CALC.onReady();
    TRACKING.onReady();
});